import { useTranslation } from 'react-i18next';
import { getTranslatedGenre } from '../../utils/i18nHelpers';

const GENRES = [
    'Fiction',
    'Novels',
    'Fantasy',
    'Sci-Fi',
    'Mystery',
    'Romance',
    'Business',
    'Self-Help',
    'Memoir/Bio',
    'History',
    'Science/Tech',
    'Other',
];

function StepOne({ formData, updateFormData }) {
    const { t } = useTranslation();
    const audiences = [
        { value: 'children', label: t('onboarding.stepOne.audiences.children') },
        { value: 'young-adult', label: t('onboarding.stepOne.audiences.youngAdult') },
        { value: 'adult', label: t('onboarding.stepOne.audiences.adult') },
        { value: 'all-ages', label: t('onboarding.stepOne.audiences.allAges') },
    ];
    const experienceLevels = [
        { value: 'beginner', label: t('onboarding.stepOne.experienceLevels.beginner') },
        { value: 'intermediate', label: t('onboarding.stepOne.experienceLevels.intermediate') },
        { value: 'advanced', label: t('onboarding.stepOne.experienceLevels.advanced') },
        { value: 'professional', label: t('onboarding.stepOne.experienceLevels.professional') },
    ];
    const handleGenreClick = (genre) => {
        if (genre === 'Other') return;
        updateFormData({ genre });
    };
    const isPresetSelected = GENRES.includes(formData.genre) && formData.genre !== 'Other';
    const isOtherSelected = !isPresetSelected && formData.genre !== '';

    return (
        <div className="step-one">
            <h2 className="step-title">{t("onboarding.stepOne.title")}</h2>
            <p className="step-subtitle">{t("onboarding.stepOne.subtitle")}</p>

            <div className="form-group">
                <label className="form-label">{t("onboarding.stepOne.projectTitle")}</label>
                <input
                    type="text"
                    className="input"
                    placeholder={t("onboarding.stepOne.projectTitlePlaceholder")}
                    value={formData.title}
                    onChange={(e) => updateFormData({ title: e.target.value })}
                />
            </div>

            <div className="form-group">
                <label className="form-label">{t("onboarding.stepOne.synopsis")}</label>
                <textarea
                    className="input textarea"
                    placeholder={t("onboarding.stepOne.synopsisPlaceholder")}
                    rows={4}
                    value={formData.synopsis}
                    onChange={(e) => updateFormData({ synopsis: e.target.value })}
                />
            </div>

            <div className="form-group">
                <label className="form-label">{t("onboarding.stepOne.genre")}</label>
                <div className="chip-group">
                    {GENRES.map(genre => (
                        <button
                            key={genre}
                            type="button"
                            className={`chip ${genre === 'Other' ? (isOtherSelected ? 'selected' : '') : (formData.genre === genre ? 'selected' : '')}`}
                            data-genre={genre}
                            onClick={() => handleGenreClick(genre)}
                        >
                            {getTranslatedGenre(t, genre)}
                        </button>
                    ))}
                </div>
                <input
                    type="text"
                    className="input"
                    placeholder={t('onboarding.stepOne.customGenrePlaceholder')}
                    value={formData.genre}
                    onChange={(e) => updateFormData({ genre: e.target.value })}
                    style={{ marginTop: '10px' }}
                />
            </div>

            <div className="form-row">
                <div className="form-group">
                    <label className="form-label">{t("onboarding.stepOne.targetAudience")}</label>
                    <div className="select-wrapper">
                        <select
                            className="select"
                            value={formData.targetAudience}
                            onChange={(e) => updateFormData({ targetAudience: e.target.value })}
                        >
                            <option value="">{t("onboarding.stepOne.selectAudience")}</option>
                            {audiences.map(a => (
                                <option key={a.value} value={a.value}>{a.label}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="form-group">
                    <label className="form-label">{t("onboarding.stepOne.experienceLevel")}</label>
                    <div className="select-wrapper">
                        <select
                            className="select"
                            value={formData.experienceLevel}
                            onChange={(e) => updateFormData({ experienceLevel: e.target.value })}
                        >
                            <option value="">{t("onboarding.stepOne.selectLevel")}</option>
                            {experienceLevels.map(l => (
                                <option key={l.value} value={l.value}>{l.label}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default StepOne;
